import React from "react";
import styled from 'styled-components'
// import YoutubeThumb from "./youtubeThumb/youtubeThumb";
import {useDispatch} from "react-redux";
import {setYoutube} from "../../../../libs/action";

export default function GuideAndPowerSeller() {
    const dispatch = useDispatch()

    const onClickGuideButton = () => {
        dispatch(setYoutube(true))
    }

    return (
        <Wrapper className='guide-powerSeller'>
            <WrapperGuide>
                <WrapperGuideText>
                    <GuideSubText>
                        조립PC를 <b>싸게 잘 사는 방법</b>
                    </GuideSubText>
                    <GuideTitleText>
                        행복쇼핑 PC 견적 서비스
                    </GuideTitleText>
                    <GuideVideoButton onClick={onClickGuideButton}>
                        구매가이드 영상보기
                    </GuideVideoButton>
                </WrapperGuideText>

                {/*<YoutubeThumb*/}
                {/*    width={237}*/}
                {/*    height={134}*/}
                {/*/>*/}
                <QrCode width={168.2} height={110}>
                    <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_est/qrcode.png`} alt='qrcode'/>
                    <span>QR 스캔하면 앱 설치가 가능합니다.</span>
                </QrCode>
            </WrapperGuide>
            <WrapperPowerSeller>
                <PowerSellerTitle>
                    꼭 확인하세요!
                </PowerSellerTitle>
                <WrapperPowerSellerText>
                    <NumberInTheCircle>1</NumberInTheCircle>
                    <PowerSellerText>
                        <b>행복쇼핑은</b> 조립<b>과 함께</b> 2년 전국 출장 A/S<b>와</b><br/> 정품 운영체제 설치 서비스 신청<b>을</b> 권장<b>합니다.</b>               </PowerSellerText>
                </WrapperPowerSellerText>
                <WrapperPowerSellerText>
                    <NumberInTheCircle>2</NumberInTheCircle>
                    <PowerSellerText>
                        <b>행복쇼핑은 PC 견적 플랫폼으로,</b> 구매와 관련된<br/> 모든 문의는 입점 미니샵을 통해 진행<b>해 주세요.</b>
                    </PowerSellerText>
                </WrapperPowerSellerText>
                <WrapperPowerSellerButton>
                    <a
                        href={`${process.env.REACT_APP_WWW_URL}/partner?sch_auth_seller=power`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <PowerSellerButton
                            alt='파워셀러 보기'
                        >
                            파워셀러 보기&nbsp;<i className="icon-angle-right"/>
                        </PowerSellerButton>
                    </a>
                </WrapperPowerSellerButton>
            </WrapperPowerSeller>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    &&{
        box-sizing: border-box; !important;
        width: 951px;
        height: 203px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-top : 1px solid #D3D3D3;
        border-bottom: 1px solid #333333;
    }
`

const WrapperGuide = styled.div`
    width: 566px;
    height: 134px;
    background-color: #F5F5F5;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 34.5px 65px 34.5px 65px;
`

const WrapperPowerSeller = styled.div`
    width: 269px;
    height: 159px;
    background-color: #FFF;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 23px 0px 21px 18px;
`

const WrapperGuideText = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: flex-start;
`

const GuideSubText = styled.span`
    font-size: 17px;
    text-align: left;
    letter-spacing: -0.42px;
    line-height: 24px;
    color: #666666;
    b{
        color: #418DED;
        font-family: bold;
    }
`

const GuideTitleText = styled.span`
    font-size: 30px;
    text-align: left;
    letter-spacing: -0.75px;
    line-height: 40px;
    color: #333333;
    font-weight: bold;
`

const GuideVideoButton = styled.span`
    width: 159px;
    height: 50px;
    background-color: #484848;
    border: 1px solid #CCCCCC;
    font-size: 14px;
    text-align: center;
    line-height: 50px;
    color: #BBBBBB;
    margin-top: 17px;
    cursor: pointer;
    :hover{
        background-color: #333333;
    }
`

// const CommingSoonImg = styled.img`
//     width: 237px;
//     height: 134px;
// `

const PowerSellerTitle = styled.span`
    font-size: 16px;
    text-align: left;
    font-weight: bold;
    letter-spacing: -0.4px;
    line-height: 20px;
    color: #333333;
    margin-bottom: 15px;
`

const WrapperPowerSellerText = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 10px;
`


const NumberInTheCircle = styled.span`
    display: inline-block;
    width: 16px;
    height: 16px;
    background-color: #CCCCCC;
    color: #FFFFFF;
    font-size: 12px;
    text-align: center;
    line-height: 16px;
    border-radius: 50%;
    margin-right: 5px;
`

const PowerSellerText = styled.span`
    font-size: 12px;
    text-align: left;
    line-height: 16px;
    color: #333333;
    b{
        color: #999999;
        font-weight: normal;
    }
`

const WrapperPowerSellerButton = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-content: center;
    margin-top: 8px;
`

const PowerSellerButton = styled.button`
    &&{
        display: flex;
        justify-content: center;
        align-items: center;

        width: 96px;
        height: 24px;
        border: none;
        background-color: #585EFC;
        color: #FFFFFF;
        font-size: 12px;
        text-align: center;
        margin-right : 18px;
        :hover{
            background-color: #484FFF;
        }
    }

`
const QrCode=styled.div`
    width: ${(props) => props.width}px;
    background: #F5F5F5;
    display:flex;
    flex-direction: column;
    align-items: center;
    img{
        width: 100%;
        height: 111px;
        border-radius: 5px;
        margin-bottom:10px;
        box-shadow: 0 5px 5px rgba(0, 0, 0, 0.05);
    }
    span{
        font-size:12px;
        letter-spacing: -0.3px;
        color:#AAAAAA;
        text-align: left;
        line-height: 16px;
        font-weight: 400;
    }
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/service/guide_powerSeller/guide_powerSeller.js